import React from "react";
import {
  PageWrap,
  Section,
  SectionTitle,
  Grid,
  Ornament,
} from "./AboutUsPageStyles";

import Carousel from "../../components/Carousel/Carousel";
import StorySection from "../../components/StorySection/StorySection";
import GalleryBlock from "../../components/GalleryBlock/GalleryBlock";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import SEO from "../../components/SEO/SEO";

import g1 from "../../assets/images/pizza.png";
import g2 from "../../assets/images/paste.png";
import g3 from "../../assets/images/papanasi.png";
import g4 from "../../assets/images/tochitura.png";

import poveste from "../../assets/images/Poveste.jpg";

import hero1 from "../../assets/images/Carousel1.jpg";
import hero2 from "../../assets/images/Carousel2.jpg";
import hero3 from "../../assets/images/Carousel3.jpg";
import hero4 from "../../assets/images/Carousel4.jpg";
import hero5 from "../../assets/images/Carousel5.jpg";
import hero6 from "../../assets/images/Carousel6.jpg";
import hero7 from "../../assets/images/Carousel7.jpg";

import pizzaImg from "../../assets/images/pizza.png";
import pasteImg from "../../assets/images/paste.png";
import papanasiImg from "../../assets/images/papanasi.png";

import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useExperience } from "../../context/ExperienceContext";

export default function AboutUsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { experience } = useExperience();

  // determină experiența curentă (din context sau din URL)
  const effectiveExperience =
    experience ||
    (location.pathname.startsWith("/meniu_restaurant")
      ? "restaurant"
      : location.pathname.startsWith("/meniu_delivery")
      ? "delivery"
      : null);

  // baza tuturor linkurilor către meniu
  const baseMenuPath =
    effectiveExperience === "restaurant"
      ? "/meniu_restaurant/"
      : "/meniu_delivery/";

  const menuHref = (cat) =>
    cat ? `${baseMenuPath}?cat=${encodeURIComponent(cat)}` : baseMenuPath;

  return (
    <PageWrap>
      <SEO
        title="Despre Noi - La Fontanella Predeal"
        description="Află povestea restaurantului La Fontanella – tradiție, rafinament și bucuria gustului autentic, servite cu pasiune în inima Predealului."
      />

      <Ornament />

      <StorySection
        eyebrow={t("about.story.eyebrow")}
        title={t("about.story.title")}
        paragraphs={[t("about.story.p1"), t("about.story.p2")]}
        ctaLabel={t("about.story.cta")}
        onCtaClick={() => navigate(baseMenuPath)} // 👈 dinamic: restaurant/delivery
        imageSrc={poveste}
        imageAlt={t("about.story.imageAlt")}
      />

      <Ornament />

      <Carousel
        images={[
          { src: hero1, alt: "Pizza pe vatră" },
          { src: hero2, alt: "Paste cremoase" },
          { src: hero3, alt: "Papanași cu smântână și dulceață" },
          { src: hero4, alt: "Papanași cu smântână și dulceață" },
          { src: hero5, alt: "Papanași cu smântână și dulceață" },
          { src: hero6, alt: "Papanași cu smântână și dulceață" },
          { src: hero7, alt: "Papanași cu smântână și dulceață" },
        ]}
      />

      <Ornament />

      <GalleryBlock
        eyebrow={t("home.gallery.eyebrow")}
        title={t("home.gallery.title")}
        text={t("home.gallery.text")}
        images={[
          { src: g1, alt: "Preparat mediteranean" },
          { src: g2, alt: "Echipă în bucătărie" },
          { src: g3, alt: "Plating rafinat" },
          { src: g4, alt: "Plating rafinat" },
        ]}
        interval={3000}
        onMenuClick={() => navigate(baseMenuPath)} // 👈 dinamic: restaurant/delivery
      />

      <Ornament />

      <Carousel
        images={[
          { src: pizzaImg, alt: "Pizza pe vatră" },
          { src: pasteImg, alt: "Paste cremoase" },
          { src: papanasiImg, alt: "Papanași cu smântână și dulceață" },
        ]}
      />

      <Ornament />

      <ContactInfo
        brand="Restaurant La Fontanella"
        address="Bulevardul Mihai Săulescu nr.111, Predeal, România"
        mapsUrl="https://www.google.com/maps?q=Mihai+Săulescu+111,+Predeal"
        accent="#d4af37"
      />

      <Ornament />
    </PageWrap>
  );
}
